<section class="footer-info">
    <div class="container">

        <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-5">
                <div class="iq-footer-box">
                    <div>
                        <div>
                            <img src="../../../../assets/images/logo_vcontract.png" alt="Viettel Group"
                                class="img-responsive footer-brand img-fluid">
                            <!-- <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)"
                                style="max-width: 280px; max-height: 70px;" alt="Viettel Group"
                                class="img-responsive footer-brand img-fluid"> -->
                        </div>

                        <p class="iq-font-black iq-pt-20 iq-mb-0 color-dark">{{ language === 'vi' ? companyInforFoots.companyNameOne : companyInforFoots.companyNameOne_EN }} </p>
                        <p class="iq-font-black color-dark">{{ language === 'vi' ? companyInforFoots.companyNameTwo : companyInforFoots.companyNameTwo_EN }}</p>

                        <p class="sub-content-ul">
                            <span class="rs-style-5 color-primary"><i
                                    class="fa fa-registered"
                                    aria-hidden="true"></i>&nbsp;{{'lading_page.footer.footer_column_one.business_registration_number' | translate}}</span>
                            <span class="color-gray-coal">{{ language === 'vi' ? companyInforFoots.businessRegistrationNumber : companyInforFoots.businessRegistrationNumber_EN }}</span>
                        </p>
                        <p class="sub-content-ul">
                            <span class="rs-style-5 color-primary"><i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"></i>&nbsp;{{'lading_page.footer.footer_column_one.company_address' | translate}}</span>
                            <span class="color-gray-coal">{{ language === 'vi' ? companyInforFoots.address : companyInforFoots.address_EN}}</span>
                        </p>
                        <p class="sub-content-ul">
                            <span class="rs-style-5 color-primary"><i
                                    class="fa fa-phone"
                                    aria-hidden="true"></i>&nbsp;{{'lading_page.footer.footer_column_one.company_hotline' | translate}}</span>
                            <span class="color-gray-coal">{{ language === 'vi' ? companyInforFoots.hotline : companyInforFoots.hotline_EN }}</span>
                        </p>
                        <p class="sub-content-ul">
                            <span class="rs-style-5 color-primary"><i
                                    class="fa fa-envelope-o"
                                    aria-hidden="true"></i>&nbsp;{{'lading_page.footer.footer_column_one.company_email' | translate}}</span>
                            <span class="color-gray-coal">{{companyInforFoots.email}}</span>
                        </p>

                    </div>
                </div>
            </div>

            <div class="col-xs-6 col-sm-4 col-md-3 col-lg-2 re4-mt-30" *ngFor="let item of listFoots">
                <div class="iq-footer-box text-left">
                    <div class="footer-content iq-pt-40">
                        <h6 class="sub-title iq-tw-6 iq-pb-10">{{getTextFooterOptions(item)}}</h6>
                        <p *ngFor="let child of item.subFooter" class="icon-prefix">
                            <a class="color-gray-coal" *ngIf="child.link !== '#rulespayment'" (click)="hyperlink(child.link, child.target)">{{getTextFooterOptions(child)}}</a>
                            <a class="color-gray-coal" *ngIf="child.link === '#rulespayment'" routerLink="/rules-and-form-of-payment">{{getTextFooterOptions(child)}}</a>
                        </p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-xs-6 col-sm-4 col-md-2 re4-mt-30">
                <div class="iq-footer-box text-left">
                    <div class="footer-content iq-pt-40">
                        <h6 class="sub-title iq-tw-6 iq-pb-10">{{'lading_page.footer.footer_column_two.products' | translate}}</h6>
                        <p class="icon-prefix"><a class="referenceFeature">{{'lading_page.footer.footer_column_two.feature' | translate}}</a></p>
                        <p class="icon-prefix"><a class="referenceFeature">{{'lading_page.footer.footer_column_two.policy' | translate}}</a></p>
                        <p class="icon-prefix"><a class="referenceContact">{{'lading_page.footer.footer_column_two.support' | translate}}</a></p>
                        <p class="icon-prefix"><a class="referenceContact">{{'lading_page.footer.footer_column_two.testimonials' | translate}}</a></p>

                    </div>
                </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-2 re-mt-30 re4-mt-30 sm-clearfix">
                <div class="iq-footer-box ">
                    <div class="footer-content iq-pt-40">
                        <h6 class="sub-title iq-tw-6 iq-pb-10">{{'lading_page.footer.footer_column_three.about_us' | translate}}</h6>
                        <p href="javascript:void(0)" class="iq-mb-10"><a routerLink="/rules-and-form-of-payment">{{'lading_page.footer.footer_column_three.rules_and_forms_of_payment' | translate}}</a></p>
                        <p href="javascript:void(0)" class="iq-mb-10"><a routerLink="">{{'lading_page.footer.footer_column_three.service_introduction' | translate}}</a></p>
                        <p href="javascript:void(0)" class="iq-mb-10"><a routerLink="">{{'lading_page.footer.footer_column_three.operation_regulation' | translate}}</a></p>
                        <p href="javascript:void(0)" class="iq-mb-10"><a routerLink="">{{'lading_page.footer.footer_column_three.terms_of_use' | translate}}</a></p>
                    </div>
                </div>
            </div> -->
            <div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 re-mt-30 re4-mt-30">
                <div class="iq-footer-box iq-pt-30">
                    <div class="footer-content">
                        <a href="http://online.gov.vn/Home/WebDetails/70474" target="_blank">
                            <img class="img-fluid" alt="" title="" src="../../../assets/images-ladi/icon/logoSaleNoti.png" width="222"
                                height="83" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>

<div class="container-fluid footer-bar">
    <div class="container">

        <div class="footer-bar-main row">
            <div class="col-auto mr-auto"><span>{{'lading_page.footer_bar.copyright' | translate}}</span>
                <a class="pl-2" href="{{hyperLinkVTT}}" target="_blank"><img class="img-fluid"
                        src="../../../assets/images/logo_vcontract_footer.png" width="10%" height="24" alt="Viettel" /></a>
            </div>
            <div class="col-auto pr-0">
                <ul class="ul-h-list">
                    <li><a class="color-gray-coal">{{'lading_page.footer_bar.use_this_account' | translate}}</a></li>
                    <li><a class="color-gray-coal">{{'lading_page.footer_bar.privacy_policy' | translate}}</a></li>
                    <li><a class="color-gray-coal">{{'lading_page.footer_bar.sitemap' | translate}}</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
